export default __webpack_public_path__ + "static/media/soybean.96779176.png";